const state = {
    expenses: [],
    expenseList: [],
    expenseId: [],
    loading: false
};

export default state;